class CardDescription {
    constructor(element) {
        function truncateText(el) {
            if (el.scrollHeight > el.clientHeight) {
                el.classList.add('card__description--truncated');
            } else {
                el.classList.remove('card__description--truncated');
            }
        }

        new ResizeObserver(() => {
            truncateText(element)
        }).observe(element);
    }
}

export default CardDescription;